var $a885cd759057f2ab$exports = {};
$a885cd759057f2ab$exports = {
    "breadcrumbs": `Migas de pan`
};


export {$a885cd759057f2ab$exports as default};
//# sourceMappingURL=es-ES.mjs.map
